<div [ngClass]="{ 'group_input': true, 'invalid': ((model.control.dirty || model.control.touched) &&  (invalid | async)) }">
  <input #inputControl appTouchKeyboard [readonly]="readonly" [attr.type]="type" [(ngModel)]="value" [attr.required]="required" (ngModelChange)="valueChanged($event)" (change)="trimValue($event)"/>
  <span class="bar"></span>
  <label><span *ngIf="required">* </span>{{ title }}</label>
</div>
